export default __webpack_public_path__ + "static/index_mission_company-d0799fa5c283f91161014a5b4536a777.jpg";